jQuery(document).ready(function($) {
	postsAjax($);
});

function postsAjax($) {

    const $body = $('body');

    let offset = 0;

    $body.on('click', '.js-loadmore-btn', function() {

        const $loadmoreBtn = $(this);
        const $loadmoreContainer = $loadmoreBtn.closest('.js-loadmore-container');
        
        const $postsAjax = $loadmoreBtn.closest('.js-posts-ajax');
        if (!$postsAjax.length) return;
        const $postsContainer = $postsAjax.find('.js-posts');
        const termId = $postsContainer.data('id');
        const postsNumber = $postsContainer.data('number');
        const loadmoreNumber = $postsContainer.data('loadmore');

        let offset = $postsContainer.attr('data-offset');
        offset = offset + loadmoreNumber;

        $loadmoreBtn.addClass('loading');

        getPostsAjax( offset, postsNumber, loadmoreNumber, termId, function(res) {
            if ( res.success == true )  {
                $loadmoreContainer.remove();
                $postsContainer.append(res.data);
                lazyLoadInstance.update();
                $postsContainer.attr('data-offset', offset);
            }
            else {
                console.log(res) ;
            }
        });

    });

    function getPostsAjax( postsOffset, postsNumber, loadmoreNumber, termId, callback ) {
        $.ajax({
            url: localizedData.adminAjaxUrl,
            type: "POST",
            cache: false,
            data: {
                action: 'get_posts_ajax',
                termId: termId,
                postsNumber: postsNumber,
                loadmoreNumber: loadmoreNumber,
                postsOffset: postsOffset
            },
            success: function(res) {
                callback(res);
            }
        });
    }

}